import { getIn } from "formik";
import { default as React } from "react";
import ReactTooltip from "react-tooltip";
import {
  CheckBoxContainer,
  CheckBoxLabel,
} from "./checkbox.components";

const Checkbox = ({ onClick, checked, label = "", labelStyles,containerStyles = {}, checkBoxWidth }) => {
  return (
    <CheckBoxContainer onClick={onClick} style={containerStyles}>
      <input type = "checkbox" className = {checkBoxWidth ? "setCustomWidth": ""} style = {{marginTop: '2px',
    
        ...(checkBoxWidth && {
          width: checkBoxWidth
        })

      }} checked={checked}/>
       
      <CheckBoxLabel style={labelStyles}>{label}</CheckBoxLabel>
    </CheckBoxContainer>
  );
};

const InputFeedback = ({ error }) => (error ? <div>{error}</div> : null);

Checkbox.Field = ({
  field: { name, value, onChange, onBlur },

  form: { errors, touched },

  id,

  label,

  disabled,

  info,

  onCustomChange = null,

  message,

  style = {},

  ctClass = null,

  checked = null,
}) => {
  const InputError = getIn(errors, name);

  const InputTouched = getIn(touched, name);

  return (
    <div className={`form-group checkbox ${ctClass}`} style={style}>
      <label style={{ cursor: disabled ? "no-drop" : "pointer" }}>
        <input
          name={name}
          id={id}
          type="checkbox"
          value={value}
          disabled={disabled}
          checked={checked !== null ? checked : value || ""}
          onChange={(e) => {
            onChange(e);

            if (onCustomChange) {
              onCustomChange(e);
            }
          }}
          onBlur={onBlur}
        />
        <span className="check-box">{label}</span>
        &nbsp;
        {info && (
          <span>
            <i
              className="fa fa-question-circle"
              data-tip
              data-for="permanent"
            />

            <ReactTooltip
              id="permanent"
              globalEventOff="click"
              delayHide={1000}
            >
              <p style={{ width: "150px" }}>{message}</p>
            </ReactTooltip>
          </span>
        )}
      </label>

      {/* {touched && touched[name] && <InputFeedback error={errors[name]} />} */}

      {touched && InputTouched && <InputFeedback error={InputError} />}
    </div>
  );
};

export { Checkbox };
